import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ThreeStateToggleSwitchComponent } from './three-state-toggle-switch.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
	declarations: [ThreeStateToggleSwitchComponent],
	imports: [CommonModule, FontAwesomeModule],
	exports: [ThreeStateToggleSwitchComponent],
})
export class ThreeStateToggleSwitchModule {}
